import { FilterParams } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { useFilter } from '@synergy/components';

import { Contact } from '../../models/contact';
import { PoolCustomerContactAutocompleteList } from '../autocomplete-list/customer-contact-autocomplete-list/pool-customer-contact-autocomplete-list';

export const CustomerContactFilter = () => {
    const { filter, getFromCache, updateCache, updateFilter, registerFilterMap } = useFilter();

    const onSelected = (contact: Contact | null) => {
        filter.delete(FilterParams.CustomerContactId);
        if (contact) {
            updateCache(`customerContact_${contact.id}`, contact?.fullName);
            filter.set(FilterParams.CustomerContactId, contact.id.toString());
        }
        updateFilter(filter);
    };

    const getDisplayValue = (contactId: unknown): string => {
        if (typeof contactId !== 'string') {
            return '';
        }

        return getFromCache(`customerContact_${contactId}`) as string;
    };

    registerFilterMap(FilterParams.CustomerContactId, getDisplayValue);

    const accountId = filter.get(FilterParams.CustomerAccountId) || filter.get(FilterParams.AccountId);

    return (
        <PoolCustomerContactAutocompleteList
            onSelected={onSelected}
            label={<FormattedMessage id="app.filter.customerContact" />}
            required={false}
            initialValue={getDisplayValue(filter.get(FilterParams.CustomerContactId)) ?? ''}
            disablePreventOverflow={true}
            accountId={accountId ? +accountId : undefined}
        />
    );
};
